export const SUGGEST_SKILL_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS = {
	hasDismissedWritePrd: 'suggest-skill-based-on-page-title:hasDismissedWritePrd',
	hasDismissedWriteHowToArticle: 'suggest-skill-based-on-page-title:hasDismissedWriteHowToArticle',
	hasDismissedResearchInsights: 'suggest-skill-based-on-page-title:hasDismissedResearchInsights',
	hasDismissedCreateActionPlan: 'suggest-skill-based-on-page-title:hasDismissedCreateActionPlan',
	hasDismissedAllSkillSuggestions:
		'suggest-skill-based-on-page-title:hasDismissedAllSkillSuggestions',
} as const;

export const SuggestSkillBasedOnPageTitleOnboardingKeys = [
	...Object.values(SUGGEST_SKILL_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS),
] as const;
